/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseLTI1p1Provider } from './BaseLTI1p1Provider';
const NonFinalizedLTI1p1ProviderParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['finalized', /* #__PURE__ */ parsers.exactly(false)],
    ['netloc', codecString],
    ['editSecret', /* #__PURE__ */ parsers.maybeNull(codecString), 'edit_secret'],
    ['lmsConsumerKey', codecString, 'lms_consumer_key'],
    ['lmsConsumerSecret', codecString, 'lms_consumer_secret'],
]), BaseLTI1p1Provider);
export class NonFinalizedLTI1p1Provider extends BaseLTI1p1Provider {
    static decode(input) {
        return NonFinalizedLTI1p1ProviderParser.decode(input).map(res => new NonFinalizedLTI1p1Provider(res));
    }
    static unsafeDecode(input) {
        return NonFinalizedLTI1p1Provider.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NonFinalizedLTI1p1ProviderParser.encode(data);
    }
    static schema() {
        return NonFinalizedLTI1p1ProviderParser.schema();
    }
}
